import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Sticker, { StickerVariants } from './Sticker';
import { FormattedNumber } from 'react-intl';
import XIcon from './XIcon';

const MPTokenTag = (props) => {
    const {
        mpt_issuance_id,
        Ticker,
        AssetScale,
        min,
        max,
        className,
    } = props;

    const value = AssetScale > 0 ? props.children / (10**AssetScale) : props.children;

    return (
        <span className={`text-nowrap ${className}`}>
            <Sticker variant={StickerVariants.LIGHT_GRAY} className="sticker-prefix">
            {value >= 0 &&
                <FormattedNumber
                    value={value}
                    maximumFractionDigits={max ?? AssetScale}
                    minimumFractionDigits={min ?? 0}
                />
            }
            </Sticker>
            <Sticker variant={StickerVariants.LIGHT_GRAY} className="sticker-suffix">
                <XIcon icon="square-m" className="text-secondary mr-0" faStyle="fadr"/>
                <Link to={`/mpt/${mpt_issuance_id}`}>
                { Ticker }
                {!Ticker &&
                    <>
                    {mpt_issuance_id?.substring(0,3)}
                    <XIcon icon="ellipsis" faStyle="fas" className="ml-0 mr-0"/>
                    {mpt_issuance_id?.substring(mpt_issuance_id?.length -3)}
                    </>
                }
                </Link>
            </Sticker>
        </span>
    );
}

MPTokenTag.defaultProps = {
    AssetScale: 0,
    className: "",
}

MPTokenTag.propTypes = {
    mpt_issuance_id: PropTypes.string.isRequired,
    Ticker: PropTypes.string,
    AssetScale: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    className: PropTypes.string,
}

export default MPTokenTag;